export default loginInfo => {
	return {}
}